/**
 * Stand-in dragon poses for look-dev: enough motion to judge the model in the real pipeline.
 * The real, sim-driven poses replace this (spec 05 §6.2). Every part moves relative to its
 * rest position (`Puppet.pose`), so the model can change shape without breaking a pose.
 */

import type { Puppet } from '../render/actors/puppet';

/** Poses step at 12 Hz, "animating on twos", so a 3D model moves like a sprite (05 §6.2). */
const POSE_HZ = 12;

export type LookdevPose = 'idle' | 'walk' | 'blow';

export function poseDragon(pup: Puppet, pose: LookdevPose, seconds: number, dir: 1 | -1 = 1): void {
  const t = Math.floor(seconds * POSE_HZ) / POSE_HZ;
  pup.face(dir);
  pup.part('mouth').visible = pose === 'blow';
  const breathe = Math.sin(t * Math.PI * 2 * 1.2) * 0.02;
  if (pose === 'walk') {
    const ph = t * Math.PI * 2 * 2.5;
    pup.pose('footNear', Math.sin(ph) * 0.16, Math.max(0, Math.cos(ph)) * 0.08);
    pup.pose('footFar', -Math.sin(ph) * 0.16, Math.max(0, -Math.cos(ph)) * 0.08);
    pup.pose('body', 0, Math.abs(Math.sin(ph)) * 0.05).rotation.z = -0.05;
    pup.pose('head').rotation.z = Math.sin(ph) * 0.04;
    pup.pose('armNear', Math.sin(ph) * -0.06);
    pup.pose('armFar', Math.sin(ph) * 0.06);
    return;
  }
  pup.pose('footNear');
  pup.pose('footFar');
  pup.pose('armNear');
  pup.pose('armFar');
  if (pose === 'blow') {
    // Lean into the blow, head forward and tipped up a little, arms back.
    pup.pose('body', 0.04).rotation.z = -0.1;
    pup.pose('head', 0.06, 0.02).rotation.z = 0.12;
    pup.pose('armNear', -0.08, 0.04);
    pup.pose('armFar', -0.08, 0.04);
    return;
  }
  pup.pose('body', 0, breathe);
  pup.pose('head', 0, breathe * 0.5);
}
